import { render, staticRenderFns } from "./DesignPortfolioHeader.vue?vue&type=template&id=76da8b9f&scoped=true&"
var script = {}
import style0 from "./DesignPortfolioHeader.vue?vue&type=style&index=0&id=76da8b9f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76da8b9f",
  null
  
)

export default component.exports